import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from  '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup;
  isSubmitted  =  false;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  result='';
  constructor(private formBuilder: FormBuilder,private httpClient: HttpClient ) { }


  ngOnInit() {

    this.contactForm  =  this.formBuilder.group({
      name: ['', Validators.required],     
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      subject: ['', Validators.required],     
      message: ['', Validators.required]
  });

  }

  onSubmit(form: FormGroup)
   {
    if (!this.contactForm.valid) {      
          return false;
        }
          
        this.httpClient.post<any>('http://api.shreemon.com/api/Email/SendWebsiteContact', this.contactForm.value).subscribe(
             resp => {
               console.log(resp);
               this.result ="Thank you for contacting us.";
               this.contactForm.reset();
               return true;
             },
               error => {         
                console.log(error);
             }); 
   }

}
